var _path;

import * as React from "react";

function SvgMinusFillCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C11.161 4 4 11.161 4 20s7.161 16 16 16 16-7.161 16-16S28.839 4 20 4zm-8.516 18.58a.745.745 0 01-.774-.773v-3.613c0-.387.322-.775.774-.775h17.032c.387 0 .774.387.774.774v3.613a.784.784 0 01-.774.775H11.484z"
  })));
}

export default SvgMinusFillCircle;